class IngredientCard extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') {
      return;
    }

    this.dataset.initialized = 'true';

    this.toggleButton = this.querySelector('[data-card-toggle]');

    this.handleToggle = this.handleToggle.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);

    this.toggleButton?.addEventListener('click', this.handleToggle);
    this.addEventListener('keydown', this.handleKeydown);
    document.addEventListener('click', this.handleDocumentClick);
  }

  disconnectedCallback() {
    this.toggleButton?.removeEventListener(
      'click',
      this.handleToggle
    );

    this.removeEventListener(
      'keydown',
      this.handleKeydown
    );

    document.removeEventListener(
      'click',
      this.handleDocumentClick
    );
  }

  handleToggle(event) {
    event.preventDefault();

    const open = this.dataset.open === 'true';

    this.setOpen(!open);
  }

  handleKeydown(event) {
    if (event.key !== 'Escape') {
      return;
    }

    this.setOpen(false);
  }

  handleDocumentClick(event) {
    if (this.contains(event.target)) {
      return;
    }

    this.setOpen(false);
  }

  setOpen(open) {
    this.dataset.open = open ? 'true' : 'false';

    this.toggleButton?.setAttribute(
      'aria-expanded',
      open ? 'true' : 'false'
    );
  }
}

if (!customElements.get('ingredient-card')) {
  customElements.define(
    'ingredient-card',
    IngredientCard
  );
}